/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import ConfirmDialog from '../../Shared/ConfirmDialog'
import { warehouseReleaseDocumentsService } from '../../../_services/warehouseReleaseDocuments.service'

import { Formik } from 'formik'
import * as Yup from 'yup'

// import Step1 from './Step1'
import Step1 from './Step1'
import Step2 from './Step2'

import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'

class WarehouseReleaseDocumentForm extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      key: 'info',
      id: this.props.id,
      dialogTitle: 'صدور حواله خروج از انبار',
      dialogText: 'آیا از ذخیره اطلاعات مطمئن هستید؟',
      data: {
        unitId: '',
        customerId: '',
        // cargoId: '',
        driverId: '',
        items: [],
        documentNumber: '',
        unitProductOperationType: this.props.unitProductOperationType
      }
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    const { id } = this.state

    if (id) {
      this.setState({ loading: true })

      await warehouseReleaseDocumentsService
        .getById(id)
        .then(res => {
          let data = res.data
          // console.log(data);
          this.setState({ data: data, loading: false })
        })
        .catch(error => {
          console.log(error)

          this.setState({ loading: false })
        })
    }
  }

  handleSubmit = (values, setSubmitting) => {
    let finalDto = values

    finalDto.items.forEach(item => {
      item.data = undefined
      item.unitProduct = undefined
    })

    // console.log(JSON.stringify(finalDto));
    console.log(finalDto)

    this.setState({ finalDto: finalDto }, () => {
      this.handleShowConfirmDialog(true)
      setSubmitting(false)
    })
  }

  handleShowConfirmDialog = val => {
    this.setState({ confirmDialogShow: val })
  }

  handleSubmitAfterConfirm = () => {
    this.handleShowConfirmDialog(false)

    this.setState({ loading: true })

    warehouseReleaseDocumentsService
      .add(JSON.stringify(this.state.finalDto))
      .then(res => {
        console.log(res.data)

        this.setState({ loading: false })
        toastr.success('ورود کالاها با موفقیت انجام شد')

        // if (setSubmitting() != undefined) {
        //   setSubmitting(false);
        // }

        this.props.onClose()
      })
      .catch(error => {
        console.log(error)
        this.setState({ loading: false })
        // setSubmitting(false);
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }

  validateForm = errors => {
    // if (Object.keys(errors).length > 0) {
    //   // // console.log(errors)
    //   let obj = errors
    //   let { createdDate, workStartDate, firstName, lastName, codeMeli, idnumber, birthDate, cellNumber, address, travelBrandId, gender, degree, childrenCount,
    //     driverDocuments,
    //     user
    //   } = obj;
    //   if (createdDate || workStartDate || firstName || lastName || codeMeli || idnumber || birthDate || cellNumber || address || travelBrandId || gender || degree || childrenCount) {
    //     this.setState({ key: "info" })
    //   } else if (driverDocuments) {
    //     this.setState({ key: "images" })
    //   }
    // }
  }

  render() {
    const { data } = this.state

    const item = Yup.object().shape({
      quantity: Yup.number()
        .nullable()
        .min(1, 'مقدار کالا')
        .required('مقدار'),
      unitProductId: Yup.string()
        .trim()
        .nullable()
        .required('محصول')
    })

    const ValidationSchema = Yup.object().shape({
      customerId: Yup.string()
        .trim()
        .nullable()
        .required('مشتری'),
      // documentNumber: Yup.string()
      //   .trim()
      //   .nullable()
      //   .required('شماره حواله راهکاران'),
      // driverId: Yup.string()
      //   .trim()
      //   .nullable()
      //   .required('راننده'),
      unitId: Yup.string()
        .trim()
        .nullable()
        .required('نام انبار'),
      items: Yup.array()
        .of(item)
        .nullable()
        .min(1, 'مقدار حداقل یک محصول')
        .required('مقدار حداقل یک محصول')
    })
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          // setSubmitting(true);
          this.handleSubmit(values, setSubmitting)
        }}
        validationSchema={ValidationSchema}>
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm
          } = props
          return (
            <div>
              <div className="row" style={{ position: 'relative' }}>
                <form onSubmit={handleSubmit}>
                  <button
                    type="submit"
                    className={
                      'icon button submit-btn ' +
                      (isSubmitting ? 'isSubmitting' : '')
                    }
                    disabled={isSubmitting}
                    onClick={() =>
                      validateForm().then(errors => {
                        console.log(errors)
                      })
                    }>
                    {isSubmitting ? (
                      <AiOutlineLoading className="mdi-spin" size="22px" />
                    ) : (
                      <AiOutlineSave size="22px" />
                    )}
                    ذخیره
                  </button>
                  <Tabs
                    transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}>
                    <Tab
                      eventKey="info"
                      title={
                        this.props.unitProductOperationType === 0
                          ? 'صدور حواله خروج از انبار'
                          : 'صدور حواله خروج از انبار'
                      }>
                      <Step1
                        {...props}
                        unitProductOperationType={
                          this.props.unitProductOperationType
                        }
                      />
                      <Step2
                        {...props}
                        unitProductOperationType={
                          this.props.unitProductOperationType
                        }
                      />
                    </Tab>
                  </Tabs>
                </form>
              </div>
              <ConfirmDialog
                open={this.state.confirmDialogShow}
                onClose={() => this.handleShowConfirmDialog(false)}
                onConfirm={() => this.handleSubmitAfterConfirm()}
                title={this.state.dialogTitle}
                text={this.state.dialogText}
              />
              {this.state.loading ? <Loading /> : ''}
            </div>
          )
        }}
      </Formik>
    )
  }
}

export default WarehouseReleaseDocumentForm
